import{h as e}from"./ids-chunk-Y6KVKFJX.js";import{a as s}from"./ids-chunk-TFRXZ5TN.js";var l=({progress:t,type:r="circular"})=>`<div class="progress-percentage ${r}" part="percentage-text">
    <ids-text font-size="14" font-weight="semi-bold" color="unset" label>${t}</ids-text>
  </div>`,w=({progress:t,type:r,percentageVisible:a,inline:i,slotted:c})=>{let n=!Number.isNaN(parseInt(t));switch(r){case s.STICKY:case s.LINEAR:{let o=`y="${r==="sticky"?"0":"12.5"}%"`;return`<svg
        xmlns="http://www.w3.org/2000/svg"
        ${e("linear-indicator",r==="sticky"&&"sticky",`${n?"":"in"}determinate`)}
        part="container"
        class="ids-loading-indicator"
      >
        <rect
          width="100%"
          height="100%"
          ${o}
          class="circle"
          part="circle"
        />
        <rect
          width="100%"
          height="100%"
          class="progress"
          part="progress"
        />
      </svg>
      ${a&&r!=="sticky"?l({progress:t,type:r}):""}`}case s.GENERATIVE_AI:return`<div class="ai-loading-indicator">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>`;default:return`<svg
        viewbox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        ${e("circular-indicator",`${n?"":"in"}determinate`,i&&"inline")}
        part="container"
        class="ids-loading-indicator"
      >
        <circle cx="50" cy="50" r="45" stroke-width="${i?8:c?1.5:3}" class="circle" part="circle" />
        <circle cx="50" cy="50" r="45" stroke-width="${i?18:c?3:6}" class="progress" part="progress" />
      </svg>
      ${a?l({progress:t}):""}<ids-overlay ${r==="contained"?'class="contained"':""} exportparts="overlay: innerOverlay" opacity="0.7" background-color="page"></ids-overlay>`}};export{l as a,w as b};
